import React from 'react'
import Wordcloud from 'react-wordcloud'

const techwords = [
  { text: 'React', value: 5 },
  { text: 'TypeScript', value: 5 },
  { text: 'JavaScript', value: 4 },
  { text: 'Azure', value: 4 },
  { text: 'Lean Startup', value: 4 },
  { text: 'Agile', value: 4 },
  { text: 'Azure DevOps', value: 4 },
  { text: '.net core', value: 3 },
  { text: 'SQL Server', value: 3 },
  { text: 'C#', value: 3 },
  { text: 'Material UI', value: 3 },
  { text: 'Java', value: 2 },
  { text: 'Git', value: 3 },
  { text: 'GitHub', value: 2 },
  { text: 'UI Fabric', value: 3 },
  { text: 'SharePoint', value: 5 },
  { text: 'MS Teams', value: 3 },
  { text: 'Office 365', value: 4 },
  { text: 'VS Code', value: 3 },
  { text: 'Visual Studio', value: 3 },
  { text: 'Scrum', value: 4 },
  { text: 'Workflow Foundation', value: 1 },
  { text: 'Entity Framework', value: 1 },
  { text: 'Delphi', value: 1 },
  { text: 'Access', value: 1 },
  { text: 'Clipper', value: 1 },
  { text: 'SQL Anywhere', value: 1 },
  { text: 'DB2', value: 1 },
  { text: 'MySQL', value: 2 },
  { text: 'Web Services', value: 2 },
  { text: 'REST', value: 2 },
  { text: 'XML', value: 2 },
  { text: 'css', value: 2 },
  { text: 'HTML4', value: 2 },
  { text: 'PWA', value: 2 },
  { text: 'OAuth', value: 2 },
  { text: 'K2', value: 2 },
  { text: 'WFC', value: 2 },
  { text: 'Web Apps', value: 2 },
  { text: 'ASP.net', value: 2 },
  { text: 'Linq', value: 2 },
  { text: 'Azure AD Apps', value: 2 },
  { text: 'SharePoint Add-Ins', value: 2 },
  { text: 'PHP', value: 2 },
  { text: 'Nearshoring', value: 4 },
  { text: 'Offshoring', value: 2 },
  { text: 'Model-driven', value: 2 },
  { text: 'Startups', value: 3 },
  { text: 'Spin-Offs', value: 3 },
  { text: 'RUP', value: 2 },
  { text: 'Microsoft', value: 3 },
  { text: 'OCR', value: 3 },
  { text: 'Machine Learning', value: 3 },
  { text: 'Blockchain', value: 3 },
];

export const TechCloud = () => (
  <Wordcloud
    words={techwords}
    options={{
      fontSizes: [10, 32],
      rotations: 3,
      rotationAngles: [0, 90],
      scale: 'sqrt',
      spiral: 'archimedean',
      enableTooltip: false
    }}
    callbacks={{
      getWordTooltip: ({ text, value }) => `${text}`,
    }}
  />
);
